// extracted by css-extract-rspack-plugin
export default {"closeButton":"_3595f592"};